interface Props {
  value: number;
  onChange?: (n: number) => void;
  step?: number;
  min?: number;
  max?: number;
  integer?: boolean; // 整数のみ受け付ける
  readOnly?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
}

export function NumberField({
  value,
  onChange,
  step = 1,
  min,
  max,
  integer = false,
  readOnly,
  placeholder,
  className,
  id,
}: Props) {
  return (
    <input
      id={id}
      type="number"
      inputMode={integer ? 'numeric' : 'decimal'}
      pattern={integer ? '[0-9]*' : undefined}
      value={Number.isFinite(value) ? value : 0}
      step={integer ? 1 : step}
      min={min}
      max={max}
      readOnly={readOnly}
      placeholder={placeholder}
      className={className}
      onChange={(e) => {
        if (!onChange) return;
        const raw = e.target.value;
        const n = parseFloat(raw);
        if (!Number.isFinite(n)) {
          onChange(0);
          return;
        }
        onChange(integer ? Math.floor(n) : n);
      }}
      onFocus={(e) => e.target.select()}
    />
  );
}
